import React from 'react';

import "../EmptyFile/EmptyFile.scss"

function EmptyFile() {
    return (<>
        <section className='error'>
            <h1>Oop's Page Not Found !</h1>
        </section>
    </>)
}

export default EmptyFile;